import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'react/api/actions/stopDetailsPopup';
import ButtonWithDropdown from 'react/components/ButtonWithDropdown';
import { 
  zonesIcon,
  zonesIconActive
} from 'react/utils/stopDetailsPopupBase64Icons.js';

class ZonesButton extends Component {
  
  toggleZones = () => {
    const { 
      routeId, stopId, zonesIsEnabled, 
      enableZonesAction, disableZonesAction 
    } = this.props;
    if (zonesIsEnabled) {
      disableZonesAction(routeId, stopId);
    } else {
      enableZonesAction(routeId, stopId);
    }
  }
  
  render() {
    const { zonesIsEnabled, styles, ...others } = this.props;
    const { dropdown, ...othersStyles } = styles;
    const dropdownStyle = {
      ...styleButtonDropdownStyle,
      ...dropdown
    }
    return (
      <ButtonWithDropdown
        isActive={zonesIsEnabled}
        iconUrl={zonesIcon}
        activeIconUrl={zonesIconActive}
        label={Monet.I18n.getResourcesByKey('routeDetails.stopDetailsPopup.zones')}
        onClick={this.toggleZones}
        styles={{dropdown: dropdownStyle, ...othersStyles}}
        {...others}/>
    );
  }
}

const styleButtonDropdownStyle = {
  right: "-123px"
}

ZonesButton.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  zonesIsEnabled: PropTypes.bool.isRequired,
  enableZonesAction: PropTypes.func.isRequired,
  disableZonesAction: PropTypes.func.isRequired
}

const mapStateToProps = ({ stopDetailsPopup }, { routeId, stopId }) => ({ 
  zonesIsEnabled: stopDetailsPopup.getIn(['actionButtons', String(routeId), String(stopId), 'zonesIsEnabled'], false)
});

const mapDispatchToProps = (dispatch) => ({
  enableZonesAction: bindActionCreators(actions.enableZones, dispatch),
  disableZonesAction: bindActionCreators(actions.disableZones, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ZonesButton);

